// ApplicationWizard.jsx
import React, { useState, useRef } from 'react';
import Form from '@rjsf/react-bootstrap';
import validator from '@rjsf/validator-ajv8';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';

import ObjectFieldTemplate from '../../components/formtemplates/index.tsx';
import Stepper from '../../components/stepper';
import DatePickerWidget from '../../components/datepicker/index.jsx';
import HorizontalRadioWidget from '../../components/radio/insex.jsx';
import FormActions from '../../components/FormActions'; // Новый компонент с кнопками
import FileUploadWidget from '../../components/FileUpload/FileUploadWidget.jsx';
import KindergartenSelectorWidget from '../../components/KindergartenSelector/index.js';

// Кастомная тема для Bootstrap 5
const bootstrap5Theme = {
  templates: {
    ButtonTemplates: {
      SubmitButton: ({ uiSchema }) => (
        <button type="submit" className="btn btn-primary">
          {uiSchema?.submitText || 'Submit'}
        </button>
      )
    },
    FieldTemplate: ({ classNames, children }) => (
      <div className={classNames}>{children}</div>
    ),
    ObjectFieldTemplate1: ({ properties, title, description }) => (
      <fieldset className="mb-4">
        {title && <legend className="h5">{title}</legend>}
        {description && <p className="text-muted">{description}</p>}
        <div className="row">
          {properties.map(prop => (
            <div key={prop.name} className="col-md-6 mb-3">
              {prop.content}
            </div>
          ))}
        </div>
      </fieldset>
    ),
    ArrayFieldItemTemplate: ({ children, onDropIndexClick, index }) => (
      <div className="card mb-3">
        <div className="card-body">
          {children}
          <button 
            type="button" 
            className="btn btn-danger mt-2"
            onClick={onDropIndexClick(index)}
          >
            Remove
          </button>
        </div>
      </div>
    ),
    ObjectFieldTemplate: ObjectFieldTemplate
  },
  widgets: {
    TextWidget: ({ id, required, label, value, onChange, options }) => (
      <div className="mb-3">
        <label htmlFor={id} className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
        <input
          type="text"
          className="form-control"
          id={id}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          {...options}
        />
      </div>
    ),
    SelectWidget: ({ id, required, label, value, onChange, options }) => (
      <div className="mb-3">
        <label htmlFor={id} className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
        <select
          className="form-select"
          id={id}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">Select an option</option>
          {options.enumOptions.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    ),
    CheckboxWidget: ({ id, required, label, value, onChange }) => (
      <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          id={id}
          checked={value || false}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor={id} className="form-check-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      </div>
    ),
    DatePickerWidget: DatePickerWidget,
    RadioWidget: HorizontalRadioWidget,
    fileUpload: FileUploadWidget,
    kindergartenSelector: KindergartenSelectorWidget
  }
};

// Схемы для каждого шага
const stepSchemas = [
  // Step 1: Дані дитини
  {
    schema: {
      type: 'object',
      required: ['childLastName', 'childFirstName', 'childBirthDate', 'childGender'],
      properties: {
        childLastName: {
          type: 'string',
          title: 'Прізвище дитини'
        },
        childFirstName: {
          type: 'string',
          title: "Ім'я дитини"
        },
        childMiddleName: {
          type: 'string',
          title: 'По батькові дитини'
        },
        childBirthDate: {
          type: 'string',
          format: 'date',
          title: 'Дата народження'
        },
        childGender: {
          type: 'string',
          title: 'Стать дитини',
          enum: ['Дівчинка', 'Хлопчик'],
          default: 'Дівчинка'
        },
        birthCertificate: {
          type: 'string',
          title: 'Серія та номер свідоцтва про народження'
        },
        certificateIssueDate: {
          type: 'string',
          format: 'date',
          title: 'Дата видачі свідоцтва'
        },
        certificateCountry: {
          type: 'string',
          title: 'Країна, що видала свідоцтво',
          enum: ['Україна', 'Іноземна держава'],
          default: 'Україна'
        },
        childAddress: {
          type: 'string',
          title: 'Адреса проживання дитини'
        }
      }
    },
    uiSchema: {
      childGender: {
        'ui:widget': 'radio'
      },
      certificateCountry: {
        'ui:widget': 'radio'
      },
      childBirthDate: {
      "ui:widget": "DatePickerWidget"
    }
    },
    layout: {
  sections: [
    {
      id: "section1",
      header: {
        title: "Дані дитини",
        align: "left",
        heading_size: 4
      },
      blocks: [
        {
          id: "block1",
          fields: {
            childLastName: { },
            childFirstName: { "width": 6 },
            childMiddleName: { "width": 6 },
            childBirthDate: { "width": 8},
            childGender: {  }
          }
        }
      ]
    },
    {
      "id": "section2",
      "header": {
        "title": "Дані свідоцтва про народження",
        "align": "left"
      },
      "blocks": [
        {
          "id": "block3",
          "fields": { 
            birthCertificate: {}, 
            certificateIssueDate: {},
            certificateCountry:{},
            childAddress: {}
           }
        }
      ]
    }
  ]
}
  },
  // Step 2: Дані про заявника
  {
    schema: {
      type: 'object',
      required: ['lastName', 'firstName', 'phone'],
      properties: {
        lastName: {
          type: 'string',
          title: 'Прізвище'
        },
        firstName: {
          type: 'string',
          title: "Ім'я"
        },
        middleName: {
          type: 'string',
          title: 'По батькові'
        },
        citizenship: {
          type: 'string',
          title: 'Громадянство',
          default: 'Україна'
        },
        taxId: {
          type: 'string',
          title: 'РНОКПП'
        },
        phone: {
          type: 'string',
          title: 'Телефон'
        },
        email: {
          type: 'string',
          format: 'email',
          title: 'Електронна пошта'
        },
        address: {
          type: 'string',
          title: 'Адреса проживання дитини'
        }
      }
    }
  },
  // Step 3: Додаткові побажання
  {
    schema: {
      type: 'object',
      properties: {
        desiredDate: {
          type: 'string',
          format: 'date',
          title: 'Бажана дата вступу в садочок'
        },
        ageMenu: {
          type: 'boolean',
          title: 'Бажаю відвідувати групу, меню за віком',
          default: false
        },
        inclusiveGroup: {
          type: 'boolean',
          title: 'Бажаю відвідувати інклюзивну групу',
          default: false
        },
        diseaseType: {
          type: 'string',
          title: 'Вид захворювання'
        },
        documentType: {
          type: 'string',
          title: 'Тип документа'
        },
        documentNumber: {
          type: 'string',
          title: 'Номер документа'
        },
        issuedTo: {
          type: 'string',
          title: 'Кому видано'
        },
        documentIssueDate: {
          type: 'string',
          format: 'date',
          title: 'Дата видачі'
        },
        documentScan: {
          type: "array",
          title: "Завантажте фото чи скан-копію документа",
          description: "Один або кілька файлів у форматі PDF, JPG, PNG. Максимальний розмір файлу 2 МБ.",
          items: {
            type: "string",
            format: "data-url"
          }
        }
      }
    },
    uiSchema: {
      ageMenu: {
        'ui:widget': 'checkbox'
      },
      inclusiveGroup: {
        'ui:widget': 'checkbox'
      },
      documentScan: {
        'ui:widget': "fileUpload"
      }
    }
  },
  // Step 4: Наявність пільг
  {
    schema: {
      type: 'object',
      properties: {
        benefitType: {
          type: 'string',
          title: 'Вид пільги'
        },
        benefitDocumentType: {
          type: 'string',
          title: 'Тип документа'
        },
        benefitDocumentNumber: {
          type: 'string',
          title: 'Номер документа'
        },
        benefitIssuedTo: {
          type: 'string',
          title: 'Кому видано'
        },
        benefitIssueDate: {
          type: 'string',
          format: 'date',
          title: 'Дата видачі'
        }
      }
    }
  },
  // Step 5: Обрання садочку
  {
    schema: {
      type: 'object',
      properties: {
         selectedKindergartens: {
              type: 'array',
              title: 'Оберіть садочки',
              items: {
                type: 'number'
              },
              maxItems: 20,
              uniqueItems: true
          }
      }
    },
    uiSchema: {
      selectedKindergartens: {
          'ui:widget': 'kindergartenSelector'
      }
    }
  },
  // Step 6: Погодження з умовами
  {
    schema: {
      type: 'object',
      required: ['agreePersonalData'],
      properties: {
        agreePersonalData: {
          type: 'boolean',
          title: 'Погоджуюсь на оброблення персональних даних',
          default: true
        }
      }
    },
    uiSchema: {
      agreePersonalData: {
        'ui:widget': 'checkbox'
      }
    }
  }
];

const ApplicationWizard = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const formRef = useRef(null);

  const nextStep = () => {
    if (currentStep < stepSchemas.length - 1) {
      setCurrentStep(currentStep + 1);
      setErrors([]);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      setErrors([]);
    }
  };

  const handleSubmit = async () => {
    if (formRef.current) {
      const { errors } = formRef.current.validate(formData);
      if (errors.length === 0) {
        setLoading(true);
        try {
          await new Promise(resolve => setTimeout(resolve, 1000)); // имитация запроса
          setErrors([{ message: 'Заявку успішно подано!' }]);
        } catch (error) {
          setErrors([{ message: 'Помилка при подачі заявки' }]);
        } finally {
          setLoading(false);
        }
      } else {
        setErrors([{ message: 'Будь ласка, заповніть всі обов\'язкові поля' }]);
      }
    }
  };

  const handleCancel = () => {
    if (window.confirm('Ви впевнені, що хочете скасувати заявку? Всі незбережені дані будуть втрачені.')) {
      setFormData({});
      setCurrentStep(0);
      setErrors([{ message: 'Заявку скасовано' }]);
    }
  };

  const handleFormChange = ({ formData }) => {
    setFormData(formData);
    if (formRef.current) {
      const { errors } = formRef.current.validate(formData);
      setIsValid(errors.length === 0);
    }
  };

  const handleSaveDraft = async () => {
    setLoading(true);
    try {
      console.log('Збереження чернетки:', formData);
      await new Promise(resolve => setTimeout(resolve, 500));
      setErrors([{ message: 'Чернетку успішно збережено!' }]);
    } catch (error) {
      setErrors([{ message: 'Помилка при збереженні чернетки' }]);
    } finally {
      setLoading(false);
    }
  };

  const stepTitles = [
    'Відомості про дитину',
    'Відомості про заявника',
    'Додаткові побажання',
    'Наявність пільг',
    'Обрання садочку',
    'Погодження з умовами'
  ];

  return (
    <div className="application-wizard-container">
      <Container>
        <Row className="justify-content-left">
          <Col xs={12}>
            <h1 className="page-title">Створення нової заявки</h1>
            
            <Stepper 
              steps={stepTitles.map((s, i) => ({ id: i, title: s }))} 
              activeStep={currentStep} 
              onStepChange={(step) => setCurrentStep(step)} 
            />

            {errors.length > 0 && (
              <Alert variant={errors[0].message.includes('успішно') ? 'success' : 'danger'} className="mb-4">
                {errors[0].message}
              </Alert>
            )}

            <Row className="justify-content-left">
              <Col md={12} lg={12} className="main-form-content">
               
                    <Form
                      ref={formRef}
                      schema={stepSchemas[currentStep].schema}
                      uiSchema={stepSchemas[currentStep].uiSchema}
                      formData={formData}
                      validator={validator}
                      onChange={handleFormChange}
                      templates={bootstrap5Theme.templates}
                      widgets={bootstrap5Theme.widgets}
                      formContext={{ getLayout: () => stepSchemas[currentStep].layout }}
                    >
                      {/* Скрываем стандартные кнопки формы */}
                      <div style={{ display: 'none' }} />
                    </Form>
                 
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      {/* Блок кнопок на всю ширину */}
      <FormActions
        currentStep={currentStep}
        totalSteps={stepSchemas.length}
        onPrev={prevStep}
        onNext={nextStep}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        onSaveDraft={handleSaveDraft}
        loading={loading}
        isValid={isValid}
        isLastStep={currentStep === stepSchemas.length - 1}
      />
    </div>
  );
};

export default ApplicationWizard;